export class PaymentRequestStatus {
  Code: number;
  Description: string;
  Hint: string;
  IconClass: string;

  constructor() {
    this.Code = null;
    this.Description = null;
    this.Hint = null;
    this.IconClass = null;
  }
}
